import React from 'react';
import FilterSection from '@client/components/search/FilterSection';
import { BASIC_FILTER_CONFIGS, DOCUMENT_TYPE } from '@client/feature/activeSubstance/config/filterConfigs';

const BasicFilters = ({ filters, onFilterChange }) => {
  return (
    <FilterSection
      filterConfigs={BASIC_FILTER_CONFIGS}
      filters={filters}
      onFilterChange={onFilterChange}
      document={DOCUMENT_TYPE}
    />
  );
};

export default BasicFilters;
